import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import mainImage from "../assets/main-v3.jpg";

const HomePage = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    const calculateAvailableHeight = () => {
      const headerHeight = document.querySelector("header")?.offsetHeight || 0;
      const footerHeight = document.querySelector("footer")?.offsetHeight || 0;
      const navigationHeight = document.querySelector("nav")?.offsetHeight || 0;
      const availableHeight = window.innerHeight - headerHeight - footerHeight - navigationHeight;
      return availableHeight;
    };

    const updateContainerHeight = () => {
      if (containerRef.current) {
        containerRef.current.style.height = `${calculateAvailableHeight()}px`;
      }
    };

    updateContainerHeight();
    window.addEventListener("resize", updateContainerHeight);

    return () => {
      window.removeEventListener("resize", updateContainerHeight);
    };
  }, []);

  return (
    <div ref={containerRef} className="flex items-center justify-center">
      <div className="w-full h-full relative">
        <Link to="/back-to-one"> {/* 2. Wrap the img */}
          <img
            src={mainImage}
            alt="Back to One"
            fetchPriority="high"
            className="absolute top-0 left-0 w-full h-full object-contain object-center transition-opacity duration-1000 ease-in-out opacity-100 bg-gray-900"
          />
        </Link>
      </div>
    </div>
  );
};

export { HomePage };